import { Button } from 'primereact/button';

const BorradoPantalla = ({ onBorrar, rol, pantalla }) => {
    const handleBorrar = () => {
        onBorrar();
    };

    return (
        <div className="card">
            <h5>Datos para borrar</h5>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-12">
                    <p>
                        <strong>Rol:</strong> {rol?.nombre}
                    </p>
                    <p>
                        <strong>Pantalla:</strong> {pantalla?.nombre}
                    </p>
                
                </div>
                <div className="field col-12 md:col-4"><span> {' '} </span>  </div>
                <div className="field col-12 md:col-4">
                    <Button label="Borrar" onClick={handleBorrar} />
                </div>
                <div className="field col-12 md:col-4"><span> {' '} </span>  </div>
            </div>
        </div>
    );
};

export default BorradoPantalla;
